/**
 * Logo Grid JS
 * -----------------------------------------------------------------------------
 *
 * All the JS for the Logo Grid component.
 */

import Splide from '@splidejs/splide';
import {AutoScroll} from '@splidejs/splide-extension-auto-scroll';
( function( app ) {
  const COMPONENT = {
    className: 'logo-grid',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.logo-grid__splide' ).each( function( key, component ) {
        const isMobile = window.matchMedia( '(max-width: 1024px)' ).matches; // Adjust breakpoint if needed

        const slider = new Splide( component, {
          type: 'loop',
          autoWidth: true,
          arrows: false,
          pagination: false,
          gap: isMobile ? '3.5rem' : '5rem', // Dynamic gap based on screen size
          autoScroll: {
            pauseOnHover: false,
            speed: 1,
          },
          perMove: 1,
          focus: 'center',
        } );

        slider.on( 'mounted', function() {
          const track = slider.Components.Elements.track;
          const totalWidth = Array.from( track.children ).reduce(
              ( width, child ) => width + child.offsetWidth,
              0,
          );

          const trackWidth = track.offsetWidth;
          if ( totalWidth < trackWidth * 2 ) {
            const requiredClones = Math.ceil( ( trackWidth * 2 ) / totalWidth );
            slider.options.clones = requiredClones;
            slider.refresh();
          }
        } );

        slider.mount( {AutoScroll} );
      } );
    },
    finalize: function() {},
  };

  app.registerComponent( 'logo-grid', COMPONENT );
} )( app );
